import { Grid, TextField, pn } from "@compass/core";
import { DiplomaType, DiplomaTypeEditResource, DiplomaTypeViewResource } from "generated/openApi";
import { CrudMode, ValidationErrors } from "@compass/core";

export const BasicInfo = (props: {
    crudMode: CrudMode;
    diplomaType: DiplomaType;
    setDiplomaType: (diplomaType: DiplomaType) => void;
    viewResource: DiplomaTypeViewResource;
    editResource: DiplomaTypeEditResource;
    validationErrors: ValidationErrors;
}) => {
    const { crudMode, diplomaType, setDiplomaType, editResource, validationErrors } = props;
    const isView = crudMode === "view";

    const handleChange = (property: keyof DiplomaType, value: any) => {
        setDiplomaType({
            ...diplomaType,
            [property]: value,
        });
    };

    return (
        <Grid container spacing="lg">
            <Grid item xs={12} md={6}>
                <TextField
                    label="Name"
                    value={diplomaType.name || ""}
                    onChange={(e) => handleChange("name", e.target.value)}
                    error={!!validationErrors?.[pn<DiplomaType>("name")]}
                    disabled={isView}
                />
            </Grid>

            {/* Add more fields? */}


        </Grid>
    );
};
